import { ThemeColors } from '~/themes/colors'

interface ShortcutsColors {
  HorizontalSeparator: ThemeColors
  KeyboardKey: {
    Background: ThemeColors
    BoxShadow: ThemeColors
  }
}

export const shortcutsColors: ShortcutsColors = {
  HorizontalSeparator: {
    default: 'gray.600',
  },
  KeyboardKey: {
    Background: {
      default: 'gray.300',
    },
    BoxShadow: {
      default: 'mask.black.20',
    },
  },
}
